'use client';

// Singleton share modal — mounted once at the AppShell root and driven by
// `useShareModalStore`. Lets ephemeral surfaces (the post-trade success
// toast, future imperative entry points) pop the full ShareModal without
// owning a trigger element.
import { c as _c } from "react/compiler-runtime";
import type { JSX } from 'react';
import { ShareModal } from '@/lib/share';
import { useShareModalStore } from '@/stores/share-modal';
export function GlobalShareModal() {
  const $ = _c(6);
  const open = useShareModalStore(_temp);
  const request = useShareModalStore(_temp2);
  const closeShareModal = useShareModalStore(_temp3);
  if (request === null) {
    return null;
  }
  let t0;
  if ($[0] !== closeShareModal) {
    t0 = next => {
      if (!next) {
        closeShareModal();
      }
    };
    $[0] = closeShareModal;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== open || $[3] !== request || $[4] !== t0) {
    t1 = <ShareModal {...request} open={open} onOpenChange={t0} />;
    $[2] = open;
    $[3] = request;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
function _temp3(s_1) {
  return s_1.closeShareModal;
}
function _temp2(s_0) {
  return s_0.request;
}
function _temp(s) {
  return s.open;
}